import type { Blog } from '@eliadmin/core/src/api/blogs/blogs-types';

export type BlogCardData = Pick<Blog, 'id' | 'name' | 'slug' | 'image' | 'created_at'> & {
  content?: string;
  excerpt?: string;
};

/** Plain text only: preview cards must not mount hidden article images/iframes. */
export function blogExcerpt(html: string | null | undefined, limit = 350): string {
  const entities: Record<string, string> = {
    amp: '&',
    lt: '<',
    gt: '>',
    quot: '"',
    apos: "'",
    nbsp: ' ',
    ndash: '–',
    mdash: '—',
    hellip: '…',
    lsquo: '‘',
    rsquo: '’',
    ldquo: '“',
    rdquo: '”',
  };
  const text = (html ?? '')
    .replace(/<(script|style)\b[^>]*>[\s\S]*?<\/\1\s*>/gi, ' ')
    .replace(/<[^>]*>/g, ' ')
    .replace(/&(#x[\da-f]+|#\d+|[a-z]+);/gi, (original, entity: string) => {
      if (!entity.startsWith('#')) return entities[entity.toLowerCase()] ?? original;
      const hex = entity[1].toLowerCase() === 'x';
      const code = Number.parseInt(entity.slice(hex ? 2 : 1), hex ? 16 : 10);
      return code > 0 && code <= 0x10ffff && !(code >= 0xd800 && code <= 0xdfff)
        ? String.fromCodePoint(code)
        : '�';
    })
    .replace(/\s+/g, ' ')
    .trim();
  const chars = Array.from(text);
  if (chars.length <= limit) return text;
  return `${chars
    .slice(0, limit)
    .join('')
    .replace(/\s+\S*$/, '')
    .trimEnd()}…`;
}

export function toBlogCardData(blog: Blog): BlogCardData {
  return {
    id: blog.id,
    name: blog.name,
    slug: blog.slug,
    image: blog.image,
    created_at: blog.created_at,
    excerpt: blogExcerpt(blog.content),
  };
}
